import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import { IconButton } from "@mui/material"

type Props = {
  direction: "next" | "previous"
  onClick: () => void
}

const PeriodNavigationButton = ({ direction, onClick }: Props) => {
  const isPrevious = direction === "previous"

  return (
    <IconButton
      aria-label={isPrevious ? "Kỳ trước" : "Kỳ sau"}
      color="primary"
      onClick={onClick}
      size="small"
      sx={(theme) => ({
        alignSelf: "center",
        border: 1,
        borderColor: "primary.main",
        borderRadius: 1,
        flexShrink: 0,
        height: theme.spacing(5),
        p: 0,
        width: theme.spacing(5),
      })}
    >
      {isPrevious ? <ChevronLeft fontSize="small" /> : <ChevronRight fontSize="small" />}
    </IconButton>
  )
}

export default PeriodNavigationButton
